import styled from "styled-components";

export const LabelText = styled.div`
  text-align: left;
  margin-bottom: 10px;
  font: normal normal normal 16px/17px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
`;
export const Text = styled.div`
  font: normal normal normal 16px/17px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
`;
